import React, { useEffect } from "react";
import styles from "./Home.module.scss";
import "react-horizontal-scrolling-menu/dist/styles.css";
import "./HorizontalScroll/hideScrollbar.css";
import { PublisherCard } from "./HorizontalScroll/PublisherCard";
import { useDataStore } from "store/DataStoreContext";
import "react-horizontal-scrolling-menu/dist/styles.css";
import usePreventBodyScroll from "./HorizontalScroll/usePreventBodyScroll";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import useWindowSize from "hook/useWindowSize";
import { LeftArrow, RightArrow } from "../Home/Components/BundleCard/arrow";

const HomePublisher = ({ history, level }) => {
  const {
    state: { publisher },
  } = useDataStore();

  const { disableScroll, enableScroll } = usePreventBodyScroll();
  const { width } = useWindowSize();

  function onWheel(apiObj, ev) {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 3;

    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  }

  return (
    <div className={styles.divPublish}>
      <div className={styles.publisherTitle}>สำนักพิมพ์</div>
      <div className={styles.pubContainer}>
        <div
          className={styles.pubContainerScroll}
          onMouseEnter={disableScroll}
          onMouseLeave={enableScroll}
        >
          {publisher.loading ? (
            <></>
          ) : (
            <div className={styles.scroll}>
              <ScrollMenu
                // LeftArrow={width >= 1000 ? LeftArrow : null}
                // RightArrow={width >= 1000 ? RightArrow : null}
                onWheel={onWheel}
              >
                {publisher.data.map((pubData) => {
                  return (
                    <PublisherCard
                      data={pubData}
                      itemId={pubData.id}
                      key={pubData.id}
                      onClick={pubData.id}
                      history={history}
                      level={level}
                    />
                  );
                })}
              </ScrollMenu>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePublisher;
